module.exports = __webpack_public_path__ + "static/media/report-arrow-down.0d476061.svg";